<template>
  <v-menu
    v-model="menu"
    bottom
    left
    offset-y
    :close-on-content-click="false"
    content-class="menu-modal"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
    </template>

    <v-card class="d-flex flex-column mt-1 rounded overflow-hidden">
      <!-- Delete -->
      <v-btn
        small
        color="secondary"
        class="justify-start"
        :loading="$loading('notifications/delete') === notification.id"
        @click="deleteNotification"
      >
        <v-icon left>mdi-trash-can</v-icon>
        {{ $t("common.delete") }}
      </v-btn>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    notification: Object,
  },

  data: () => ({
    menu: false,
  }),

  methods: {
    deleteNotification() {
      this.$store
        .dispatch("notifications/delete", this.notification)
        .catch(() => {
          this.$toast.error("Error while deleting notification.");
        });
    },
  },
};
</script>

<style></style>
